define('gameBrowser/GameRunner',[
    'knockout',
    'underscore',
    'jquery',
    'common/tools',
    'bluebird'
], function (ko, _, $, tools, Promise) {

    var GameRunner = function (
        LOG,
        session,
        settings,
        LaunchGameCommand,
        GameProviderModel,
        launchStrategy,

        game,
        container,
        isPractice,
        closeGameFn,
        openGameRulesFn
    ) {

        var PROVIDER_TYPE_KEY = 'providerType';

        var PROVIDERS = {
            'NONE': {
                'NOT_STARTED': 'NOT_STARTED',
                'LOADING': 'LOADING',
                'ERROR': 'ERROR'
            }
        };

        /**
         * Use this for urls which need to load inside the game webview.
         *
         * The game webview in native will close if it detects links back to casumo
         * unless they are made native safe with this function. This is a temporary
         * workaround while waiting for a new native version rollout.
         *
         * Don't use for return urls which navigate away from the game.
         *
         * @param {String} originalUrl
         */
        function nativeSafeUrl(originalUrl) {

            var hostParts,
                nativeHost;

            if (!window.native) {
                return originalUrl;
            }

            hostParts = window.location.host.split('.');
            hostParts[0] = 'mobile-games';
            nativeHost = hostParts.join('.');

            // The slash is included to ensure encoded host params are not replaced
            return originalUrl.replace(
                '/' + window.location.host,
                '/' + nativeHost
            );

        }

        /**
         * Old versions of the native app will break if the game interface is added.
         *
         * @return {Boolean}
         */
        function isGameInterfaceSupported() {
            return !window.native || !!window.native.version;
        }

        function toNetentUrl(providedSession) {

            var params = {
                gameId: providedSession.parameters.GAME_ID,
                sessionId: providedSession.sessionId,
                gameServer: providedSession.parameters.GAME_API_URL,
                lobbyURL: window.location.origin + '/return-from-game/netent',
                language: settings.selectedLanguage().code,
                staticServer: providedSession.parameters.GAME_STATIC_URL
            };

            if (isGameInterfaceSupported()) {
                // params.pluginURL = window.location.origin + '/gameInterfaces/netent';

                // Using this hack to avoid running mobile.dev on https (which is extremely slow to reload.)
                params.pluginURL = 'https://m.casumotest.com/gameInterfaces/netent';
            }

            return nativeSafeUrl(window.location.origin + '/gamelaunchers/netent.html?') + $.param(params);
        }

        function toGreentubeUrl(providedSession) {
            var parameters = providedSession.parameters,
                hostname = parameters.hostname,
                gameId = parameters.providerGameId,
                html5GamePath = parameters.html5GamePath,
                clientAuthToken = parameters.clientAuthToken;
            return 'https://' + hostname + '/Nrgs/B2B/Web/' + html5GamePath + '/Cash/Games/' + gameId + '/Sessions/' + clientAuthToken + '/Show/HTML5';
        }

        function toWMSUrl(providedSession) {
            return providedSession.parameters.gameUrl + '?' + $.param(_.omit(providedSession.parameters, 'gameUrl', 'providerType')) + '&lobbyurl=' + encodeURIComponent(window.location.href);
        }

        function toThunderkickUrl(providedSession) {
            return providedSession.parameters.gameUrl + '?' + $.param(_.omit(providedSession.parameters, 'gameUrl', 'providerType')) + '&lobbyUrl=' + encodeURIComponent(window.location.href);
        }

        function toRelaxUrl(providedSession) {

            var params = _.extend(_.omit(providedSession.parameters, 'gameUrl', 'providerType'), {
                homeurl: window.location.href
            });

            if (isGameInterfaceSupported()) {
                params.rciframeurl = window.location.origin + '/gameInterfaces/quickspin';
            }

            return providedSession.parameters.gameUrl + '?' + $.param(params);
        }

        function toEvolutionUrl(providedSession) {
            return providedSession.parameters.gameUrl + '&JSESSIONID=' + encodeURIComponent(providedSession.parameters.sessionid);
        }

        function toRgsUrl(providedSession) {
            return providedSession.parameters.gameUrl + '?' + $.param(_.omit(providedSession.parameters, 'gameUrl', 'providerType'));
        }

        function toPlayNGoUrl(providedSession) {

            var url,
                params;

            params = _.extend(_.omit(providedSession.parameters, 'gameUrl', 'providerType'), {
                lobby: window.location.href
            });

            if (isGameInterfaceSupported()) {
                params.iframeoverlay = window.location.origin + '/gameInterfaces/playngo';
            }

            url = providedSession.parameters.gameUrl + '?' + $.param(params);

            return url + '&reloadgame=' + encodeURIComponent(url);
        }

        function toMicrogamingUrl(providedSession) {
            var parameters = providedSession.parameters,
                gameUrl = parameters.gameUrl,
                lobbyName = parameters.lobbyName,
                lobbyURL = encodeURIComponent(window.location.href),
                bankingURL = encodeURIComponent(window.location.origin + '/cash/history/bets'),
                authtoken = parameters.authtoken,
                csid = parameters.csid,
                ul = parameters.ul,
                gameId = parameters.gameId,
                isReal = parameters.isReal;
            if (isReal === 'true') {
                return gameUrl + lobbyName + '/' + gameId + '/' + ul + '?casinoID=' + csid + '&lobbyURL=' + lobbyURL + '?&bankingURL=' + bankingURL + '&loginType=VanguardSessionToken&authToken=' + authtoken + '&isRGI=true';
            } else {
                return gameUrl + lobbyName + '/' + gameId + '/' + ul + '?loginType=VanguardSessionToken&isPracticePlay=true&casinoId=' + csid + '&isRGI=true&authToken=&lobbyURL=' + lobbyURL;
            }
        }

        var mapToUrl = function (responseData) {
            var providedSession = responseData.providedSession,
                providerType = providedSession.parameters[PROVIDER_TYPE_KEY];

            switch (providerType) {
                case 'NETENT_FLASH':
                case 'NETENT_GAME_INCLUSION':
                    return toNetentUrl(providedSession);
                case 'THUNDERKICK_UNITY_WITH_FLASH_FALLBACK':
                    return '/';
                case 'THUNDERKICK_MOBILE':
                    return toThunderkickUrl(providedSession);
                case 'GREENTUBE_HTML5':
                    return toGreentubeUrl(providedSession);
                case 'WMS_MOBILE':
                    return toWMSUrl(providedSession);
                case 'RELAX_HTML5':
                    return toRelaxUrl(providedSession);
                case 'EVOLUTION_MOBILE':
                    return toEvolutionUrl(providedSession);
                case 'MICROGAMING_HTML5':
                    return toMicrogamingUrl(providedSession);
                case 'RGS_HTML5':
                    return toRgsUrl(providedSession);
                case 'PLAYNGO_MOBILE':
                    return toPlayNGoUrl(providedSession);
                default:
//                    LOG.error('Unknown type of game when launching game', game.slug, 'with provider type', providerType);
                    return '/';
            }
        };

        var GOLDEN_RATIO = 1.61803398875;
        var NoProviderModel = function (provider) {
            GameProviderModel.apply(this, [provider, window, GOLDEN_RATIO]);
        };
        var NotStartedModel = function () {
            NoProviderModel.apply(this, [PROVIDERS.NONE.NOT_STARTED]);
        };
        var LoadingModel = function () {
            NoProviderModel.apply(this, [PROVIDERS.NONE.LOADING]);
        };

        var ProviderErrorModel = function () {
            NoProviderModel.apply(this, [PROVIDERS.NONE.ERROR]);
        };

        var NOT_STARTED_MODEL = new NotStartedModel();
        var LOADING_MODEL = new LoadingModel();
        var PROVIDER_ERROR_MODEL = new ProviderErrorModel();

        var self = this,
            nonRealProviders = _.values(PROVIDERS.NONE);

        closeGameFn = closeGameFn || function () {LOG.warn('closeGameFn is a noop for', self); };
        openGameRulesFn = openGameRulesFn || function () {LOG.warn('openGameRulesFn is a noop for', self); };

        self.game = game;

        self.size = {
            width: ko.observable('100%'),
            height: ko.observable('100%')
        };

        self.isLoading = ko.deferredComputed(function () {
            return self.model() === LOADING_MODEL;
        });

        self.hasStarted = ko.deferredComputed(function () {
            return !_.includes(nonRealProviders, self.model().providerType);
        });

        self.model = ko.observable(NOT_STARTED_MODEL);

        self.hasFailed = ko.deferredComputed(function () {
            return self.model().providerType === PROVIDERS.NONE.ERROR || self.model().providerType === PROVIDERS.NONE.LOGIN_NEEDED;
        });

        self.supportsEvents = ko.deferredComputed(function () {
            return ko.unwrap(self.model().supportsEvents);
        });

        self.isPractice = ko.deferredComputed(function () {
            return ko.unwrap(isPractice);
        });

        self.reloadBalance = function () {
            var modelReloadBalance = self.model().reloadBalance;
            modelReloadBalance.apply(modelReloadBalance, arguments);
        };

        var launchGameCommand = new LaunchGameCommand({
                gameName: ko.deferredComputed(function () { return self.game.providerGameId(); }),
                playForFun: self.isPractice,
                platform: 'mobile'
            });

        self.createGameModel = function(providerType) {
            return new NoProviderModel(providerType);
        };

        var deferredStart;
        self.start = function () {

            if(!deferredStart || deferredStart.state() !== 'pending') {
                deferredStart = new Promise(function (resolve, reject) {

                    self.model(LOADING_MODEL);

                    launchGameCommand.dispatch(function (response) {
                        var responseData = response.responseData;
                        var providedSession = responseData.providedSession;
                        var providerType = providedSession.parameters[PROVIDER_TYPE_KEY];

                        // Mobile game needs no extra functionality from the default no provider model, so
                        // we can add the url to it
                        var model = self.createGameModel(providerType);
                        model.gameUrl = mapToUrl(responseData);

                        launchStrategy()(model, game, self.isPractice());

                        resolve(model);
                    }, reject);

                });

                deferredStart.done(self.model);

                deferredStart.fail(function (failure) {
                    LOG.error('Failed to start game with slug', self.game.slug, failure);
                    self.model(PROVIDER_ERROR_MODEL);
                });

                return deferredStart;
            }
        };

        self.restart = self.start;

        self.dispose = function () {
            self.model().isDisposed = true;
        };
    };

    return GameRunner;


});


